import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../ui";

type Props = {
  show: boolean;
  failure?: {
    code?: string;
    message?: string;
    reason?: string;
    chargeId?: string;
    paymentIntentId?: string;
    invoiceId?: string;
    customerId?: string;
    receiptEmail?: string;
    createdAt?: string | Date | null;
    at?: string | Date | null;
  } | null;
};

const PaymentFailedModal = ({ show, failure }: Props) => {
  const navigate = useNavigate();
  if (!show) return null;

  const message =
    failure?.message?.trim() ||
    "Your payment couldn't be processed. Please update your billing details to restore access.";
  const createdAtRaw = failure?.createdAt || failure?.at || null;
  const createdAt = createdAtRaw ? new Date(createdAtRaw) : null;
  const createdAtText =
    createdAt && !Number.isNaN(createdAt.getTime())
      ? createdAt.toLocaleString(undefined, {
          year: "numeric",
          month: "short",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        })
      : null;

  return (
    <div
      className="fixed inset-0 z-[10001] flex items-center justify-center bg-black/45 px-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="payment-failed-title"
    >
      <div className="w-full max-w-[420px] rounded-[12px] border border-light-grey bg-white p-6 shadow-[0_12px_40px_rgba(15,16,17,0.18)]">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-red-50">
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden
          >
            <path
              d="M12 8v5m0 3h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
              stroke="#DC2626"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <h2
          id="payment-failed-title"
          className="text-center text-[22px] font-semibold leading-tight text-dark-black"
        >
          Payment unsuccessful
        </h2>

        <p className="mt-3 text-center text-sm leading-relaxed text-dark-grey">
          {message}
        </p>

        {createdAtText ? (
          <p className="mt-2 text-center text-[11px] text-dark-grey/80">
            Failed on {createdAtText}
          </p>
        ) : null}

        <p className="mt-4 text-center text-xs leading-relaxed text-dark-grey">
          Open Billing to update your card and complete payment for your current plan.
        </p>

        <div className="mt-5 flex justify-center">
          <Button
            variant="primary"
            size="md"
            onClick={() => navigate("/settings/billing")}
          >
            Go to Billing
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailedModal;
